export default "__VITE_ASSET__C7ek4tGD__ 1200w";